export default __webpack_public_path__ + "static/media/twitter.584ebe0b.svg";